import Reveal from "@/components/Reveal";
import Monogram from "@/components/Monogram";
import { GALLERY } from "@/content/site";

export default function Gallery() {
  // varied heights
  const heights = [560, 420, 640, 380, 520, 460, 600, 380, 540, 460, 580, 420];
  return (
    <>
      <section className="pt-44 pb-16 px-6 lg:px-14 bg-[#F5F2ED] relative overflow-hidden">
        <Monogram size={620} opacity={0.05} color="#4A3E39" className="absolute -bottom-40 -left-40 hidden md:block" />
        <div className="max-w-[1500px] mx-auto">
          <Reveal>
            <div className="eyebrow mb-6">Gallery</div>
            <h1 className="font-display font-light text-ivory-800 text-6xl md:text-8xl lg:text-[120px] leading-[0.95]">
              The <em className="italic">edit</em>.
            </h1>
            <p className="mt-10 max-w-xl text-[15px] leading-[1.9] text-ivory-700">
              Selected work — hair, hands, faces, and the room they happened in.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="px-6 lg:px-14 pb-32 bg-[#F5F2ED]">
        <div className="max-w-[1500px] mx-auto columns-1 sm:columns-2 lg:columns-3 gap-6 lg:gap-8 space-y-6 lg:space-y-8">
          {GALLERY.map((g, i) => (
            <Reveal key={i} delay={i * 40} className="break-inside-avoid zoom-wrap relative group">
              <img
                src={g.url}
                alt={g.caption}
                style={{ height: heights[i % heights.length] }}
                className="zoom-img w-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-[#2C2724]/0 group-hover:bg-[#2C2724]/35 transition-colors duration-500 flex items-end p-6 opacity-0 group-hover:opacity-100">
                <span className="font-display italic text-ivory-100 text-xl">{g.caption}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
